<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Calendar Event</h3>
           </template>
           <div class="row">
              <div class="col-md-9">
                 <nav class="row">
                    <ol class="breadcrumb arr-right bg-breadcrum">
                       <li class="breadcrumb-item">
                          <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                       </li>
                       <li class="breadcrumb-item">
                          <router-link to="calendar">Calendar</router-link>
                       </li>
                       <li class="breadcrumb-item active">Calendar Event</li>
                    </ol>
                 </nav>
              </div>
              <div class="col-md-3">
                 <router-link to="/hr/addcalendarevent" class="btn btn-primary float-right"><i class="fa fa-plus"></i>&nbsp;Add Calendar Event</router-link>
              </div>
           </div>
           <hr style="margin-top:-10px"/>
           <div class="table-responsive ">
              <table class="table table-striped table-hover ">
                 <thead>
                    <tr>
                       <th width="10">#</th>
                       <th width="120">Date</th>
                       <th width="80">Type</th>
                       <th width="600">Name</th>
                       <th width="280">Display</th>
                       <th width="80">Action</th>
                    </tr>
                 </thead>
                 <tbody>
                    <tr v-for="r,i in items">
                       <td>{{i+1}}</td>
                       <td><i class="fa fa-calendar-o"></i> {{getDate(r.date_event)}}</td>
                       <td>
                          <span v-if="r.event_type == 1">
                              <span class="badge badge-pill badge-warning m-size">Critical Day</span>
                          </span>
                          <span v-else-if="r.event_type == 2">
                              <span class="badge badge-pill badge-primary m-size">Holiday</span>
                          </span>
                          <span v-else-if="r.event_type == 3">
                              <span class="badge badge-pill badge-info m-size">Meeting</span>
                          </span>
                          <span v-else-if="r.event_type == 4">
                              <span class="badge badge-pill badge-success m-size">Celebration</span>
                          </span>
                          <span v-else-if="r.event_type == 5">
                              <span class="badge badge-pill badge-danger m-size">Block off</span>
                          </span>
                          <span v-else-if="r.event_type == 6">
                              <span class="badge badge-pill badge-info m-size">Company Party</span>
                          </span>
                          <span v-else-if="r.event_type == 7">
                              <span class="badge badge-pill badge-danger m-size">Rest Day</span>
                          </span>
                       </td>
                       <td>   
                          <span class="fa fa-star-o" style="color:darkorange"></span> {{r.name}}
                       </td>   
                       <td>
                         <span v-if="r.sub_id == null"> 
                               <b>(ESS)</b> Display to
                              <i class="fa fa-arrow-right"></i>
                              <span class="badge badge-pill badge-info m-size">All Sub Department</span>
                           </span>
                           <span v-else-if="r.sub_id == 1">
                              <b>(ESS)</b> Display to
                              <i class="fa fa-arrow-right"></i>
                              <span class="badge badge-pill badge-pill m-size" style="background: rgb(158, 9, 245);color:aliceblue">{{r.sub_department_name}}</span>
                           </span>
                            <span v-else-if="r.sub_id == 2">
                                <b>(ESS)</b> Display to
                              <i class="fa fa-arrow-right"></i>
                              <span class="badge badge-pill badge-secondary m-size">{{r.sub_department_name}}</span>
                           </span>
                            <span v-else-if="r.sub_id == 3">
                                <b>(ESS)</b> Display to
                                <i class="fa fa-arrow-right"></i>
                              <span class="badge badge-pill badge-dark m-size">{{r.sub_department_name}}</span>
                           </span>
                            <span v-else-if="r.sub_id == 4">
                                <b>(ESS)</b> Display to
                                <i class="fa fa-arrow-right"></i>
                              <span class="badge badge-pill badge-warning m-size">{{r.sub_department_name}}</span>
                           </span>
                            <span v-else-if="r.sub_id == 5">
                                <b>(ESS)</b> Display to
                               <i class="fa fa-arrow-right"></i>
                              <span class="badge badge-pill badge-success m-size">{{r.sub_department_name}}</span>
                           </span>
                            <span v-else-if="r.sub_id == 6">
                                <b>(ESS)</b> Display to
                                <i class="fa fa-arrow-right"></i>
                              <span class="badge badge-pill badge-primary m-size">{{r.sub_department_name}}</span>
                           </span>
                             <span v-else-if="r.sub_id == 7">
                                <b>(ESS)</b> Display to
                                <i class="fa fa-arrow-right"></i>
                              <span class="badge badge-pill badge-info m-size">{{r.sub_department_name}}</span>
                           </span>
                          
                        </td>
                       <td>
                          <button class="btn btn-primary btn-xs btn-circle"  @click="get_selected_id(r)" v-b-modal.update-calendar v-b-tooltip.hover><i class="fa fa-pencil"></i></button>
                          <button class="btn btn-danger btn-xs btn-circle"   @click = "deleteItem(r.id, index)" v-b-tooltip.hover title="Remove Calendar Event"><i class="fa fa-times"></i></button>
                        </td>
                    </tr>
                 </tbody>
              </table>
           </div>
              <!-- MODAL FOR UPDATE RECORD  -->
              <b-modal id="update-calendar" ref="hide-calendar-modal"  size="l" hide-footer>
                  <h3>Update Calendar Event <i class="fa fa-calendar-o"></i></h3>
                  <div class="form-group">
                    <label>Name:</label>
                    <input type="text" class="form-control" v-model="selected_item.name">
                   </div>
                   <div class="form-group">   
                    <label>Type:</label>
                    <select class="form-control" v-model="selected_item.event_type" required>
                        <option value="">-- Choose One --</option>
                        <option value="1">Critical Day</option>
                        <option value="2">Holidays</option>
                        <option value="3">Meeting</option>
                        <option value="4">Celebration</option>
                        <option value="5">Block off</option>
                        <option value="6">Company Party</option>
                        <option value="7">Rest Day</option>
                     </select>
                  </div>
                  <div class="form-group">  
                      <label>Date:</label>    
                      <input type="date" v-model="selected_item.date_event" class="form-control" required>
                   </div>
                  <div class="form-group">     
                    <label>ESS Display to :</label>
                    <select class="form-control" v-model="selected_item.sub_department_id" required>
                        <option value="0" selected>Display All</option>
                        <option v-for="sub_department in sub_departments" :key="sub_department.id"  :value="sub_department.id">{{ sub_department.sub_department_name }}</option>
                     </select>
                  </div>
                  <div class="form-group">
                    <button class="btn btn-info float-right" @click="update_calendar"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
                  </div>
              </b-modal>
        </card>
     </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card
  },
  data() {
    return {
      items: [],
      selected_item:'',
      ub_departments: []
    };
  },
  created: function() {
    this.get_calendar()
    this.getSubdepartments()
  },
  methods: {
    getSubdepartments() {
      axios.get('api/subdepartments')
      .then(response => {
        this.sub_departments = response.data
      })
      .catch(error => {
        console.log(error.response)
      });
    },

    get_selected_id(item) {
        this.selected_item = item;
    },

    deleteItem(id, index) {

      /* USING SWEET ALERT */
        this.$swal({
            title: 'Are you sure?',
            text: 'You can\'t revert your action',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes Delete it!',
            cancelButtonText: 'No, Keep it!',
            showCloseButton: false,
            showLoaderOnConfirm: true
            })
            .then((isConfirm) => {
              if (isConfirm === true) {
                axios.delete('api/calendar/delete/' + id)
                    .then(response => {
                    this.get_calendar() // reloader 
                    this.$swal('Deleted', 'You successfully deleted this file', 'success')
                })
                .catch(response => {
                    console.log(response);
                    this.$swal('Error Code', 'Please contact Web developer', 'error')
                });
            }
          });
      },

    update_calendar(e){
      e.preventDefault();
      this.$swal({
            title: 'Are you sure?',
            text: 'Do you want to save this changes',
            type: 'warning',
            showCancelButton: true,
            showCloseButton: false,
          })
          .then((isConfirm) => {
            if (isConfirm === true) {
                //--> HTTP POST REQUEST
                axios.post('api/calendar/update/' + this.selected_item.id,{
                    'name':this.selected_item.name,
                    'event_type':this.selected_item.event_type,
                    'date_event':this.selected_item.date_event,
                    'sub_department_id':this.selected_item.sub_department_id,
                })
                  .then(response => {
                      this.$swal({
                        type: 'success',
                        title: 'Updated',
                        html: 'Data has been successfully change.',
                        showConfirmButton: true,
                        timer: 4000
                      })
                      this.$refs['hide-calendar-modal'].hide();
                      this.get_calendar()
                  })
                  .catch(error => {
                      console.log(response);
                      this.$swal('Error Code', 'Please contact Web developer', 'error')
                  });
                //--> END HTTP POST REQUEST  
            }
          })
      },


    get_calendar() {
      axios.get("api/allcalendar")
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    getDate(date) {
      return moment(date).format("MMM DD YYYY");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-calendar/todo-holidays.vue